import LossAndDamageClaimsTypes from './LossAndDamageClaimsTypes';

export const setLossAndDamageFilters = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_CLAIMS_FILTERS,
  payload,
});
export const setLossAndDamageFilterType = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_FILTER_TYPE,
  payload,
});
export const setSelectedLADClaims = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_SELECTED_CLAIMS,
  payload,
});
export const setLADClaimEditDrawer = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_CLAIM_EDIT_DRAWER,
  payload,
});

export const getLossAndDamageListInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIMS_LIST_PROGRESS,
  payload,
});
export const getLossAndDamageListInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIMS_LIST_SUCCESS,
  payload,
});
export const getLossAndDamageListInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIMS_LIST_ERROR,
  payload,
});
export const setLossAndDamageClaimsList = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_CLAIMS_LIST,
  payload,
});
export const refreshLossAndDamageClaimsList = (payload) => ({
  type: LossAndDamageClaimsTypes.REFRESH_CLAIMS_LIST,
  payload,
});

export const deleteLossAndDamageClaimsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.DELETE_CLAIMS_PROGRESS,
  payload,
});

export const getLossAndDamageClaimDetailsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_DETAILS_PROGRESS,
  payload,
});
export const getLossAndDamageClaimDetailsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_DETAILS_SUCCESS,
  payload,
});
export const getLossAndDamageClaimDetailsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_DETAILS_ERROR,
  payload,
});

export const updateLossAndDamageClaimDetailsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.UPDATE_CLAIM_DETAILS_PROGRESS,
  payload,
});

export const createLDClaimInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.CREATE_CLAIM_PROGRESS,
  payload,
});
export const createLDClaimInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.CREATE_CLAIM_SUCCESS,
  payload,
});
export const createLDClaimInError = (payload) => ({
  type: LossAndDamageClaimsTypes.CREATE_CLAIM_ERROR,
  payload,
});
export const createLDClaimReset = (payload) => ({
  type: LossAndDamageClaimsTypes.CREATE_CLAIM_RESET,
  payload,
});

export const sendLDClaimEmailToCarrierInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.SEND_EMAIL_TO_CARRIER_PROGRESS,
  payload,
});

export const checkLDClaimXPOExportInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.CHECK_EXP_EXPORT_PROGRESS,
  payload,
});
export const checkLDClaimXPOExportInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.CHECK_EXP_EXPORT_SUCCESS,
  payload,
});
export const checkLDClaimXPOExportInError = (payload) => ({
  type: LossAndDamageClaimsTypes.CHECK_EXP_EXPORT_ERROR,
  payload,
});

export const setLDClaimViewType = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE,
  payload,
});
export const setLDClaimViewTypeInitial = (payload) => ({
  type: LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL,
  payload,
});

export const getLDClaimsTableViewColumnsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_TABLE_VIEW_COLUMNS_PROGRESS,
  payload,
});
export const getLDClaimsTableViewColumnsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_TABLE_VIEW_COLUMNS_SUCCESS,
  payload,
});
export const getLDClaimsTableViewColumnsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_TABLE_VIEW_COLUMNS_ERROR,
  payload,
});

export const getLDClaimsSortingFieldsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_SORTING_FIELDS_PROGRESS,
  payload,
});
export const getLDClaimsSortingFieldsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_SORTING_FIELDS_SUCCESS,
  payload,
});
export const getLDClaimsSortingFieldsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_SORTING_FIELDS_ERROR,
  payload,
});

export const saveLDClaimsTableViewColumnsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_PROGRESS,
  payload,
});
export const saveLDClaimsTableViewColumnsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_SUCCESS,
  payload,
});
export const saveLDClaimsTableViewColumnsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_ERROR,
  payload,
});

export const validateDuplicateClaimInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.VALIDATE_DUPLICATE_CLAIM_PROGRESS,
  payload,
});

export const getLADClaimNotesInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_NOTES_PROGRESS,
  payload,
});
export const getLADClaimNotesInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_NOTES_SUCCESS,
  payload,
});
export const getLADClaimNotesInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_NOTES_ERROR,
  payload,
});

export const getLADClaimSettlementsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_SETTLEMENTS_PROGRESS,
  payload,
});
export const getLADClaimSettlementsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_SETTLEMENTS_SUCCESS,
  payload,
});
export const getLADClaimSettlementsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_SETTLEMENTS_ERROR,
  payload,
});

export const getLADClaimItemsInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_ITEMS_PROGRESS,
  payload,
});
export const getLADClaimItemsInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_ITEMS_SUCCESS,
  payload,
});
export const getLADClaimItemsInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_ITEMS_ERROR,
  payload,
});
export const getLADClaimEmailStatusInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_EMAIL_STATUS_PROGRESS,
  payload,
});
export const getLADClaimEmailStatusInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_EMAIL_STATUS_SUCCESS,
  payload,
});
export const getLADClaimEmailStatusInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_EMAIL_STATUS_ERROR,
  payload,
});
export const getLADClaimFilesInProgress = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_FILES_PROGRESS,
  payload,
});
export const getLADClaimFilesInSuccess = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_FILES_SUCCESS,
  payload,
});
export const getLADClaimFilesInError = (payload) => ({
  type: LossAndDamageClaimsTypes.GET_CLAIM_FILES_ERROR,
  payload,
});
